import { HttpClient } from '../../../httpClient'
import { OpalApi } from '../../../schema'

type UpdateViewV3 = OpalApi<'UpdateViewV3', 200>

export const updateView: UpdateViewV3 = async (args = {}) => {
  const viewId = args.params?.path.view_id

  if (typeof viewId !== 'string') {
    throw new Error('Must supply a valid view_id.')
  }

  const url = new URL(`/loupe/v3/views/${viewId}`, window.location.origin)

  return HttpClient()
    .patch(url.toString(), args.requestBody)
    .then((res) => res.data)
}
